<template>
    <!--
        Компонент інфо-блоків - читабельний лаконічний дизайн (маленький)
    -->

    <div class="d-flex flex-column gap-2" style="max-height: 500px;overflow: auto;">
        <div
            v-for="item in form"
            :key="item"
            :class="['border', 'rounded', 'p-2', 'info-block-small', getPaymentStatusClass(item)]"
            :style="`cursor: pointer; border-left: 3px solid var(--vz-${item.color || 'secondary'}) !important;`"
            @click="item.copy == true ? copy(item.title + ' ' + item.value): noCopy()"
        >
            <p class="text-uppercase text-muted mb-1 fs-11">{{ item.title }}</p>
            <p :class="['fs-15', 'fw-semibold', 'mb-0', 'breakText', getPaymentTextClass(item)]">{{ item.value }}</p>
        </div>
    </div>
</template>

<script>
import {copy} from '@/usabilityScripts/copy.js'

export default{
    props: ['obj'],
    data(){
        return{
            form: "" // Змінна для зберігання даних інформаційних блоків
        }
    },
    created(){
        // Ініціалізація змінної даних інформаційних блоків з отриманими даними
        this.form = this.obj
    },
    methods: {
        copy(item){
            // копіювання
            if(copy(item) == true) {
                this.$toast.success(this.$t('Copied'));
            } else {
                this.$toast.error(`Fucking mistake, contact Borys`);
            }
            return
        },
        noCopy(){
            this.$toast.error(this.$t('TrytoClick'));
        },
        // Перевірка чи значення є датою у форматі YYYY-MM-DD
        isDateValue(value) {
            if (!value || typeof value !== 'string') return false
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/
            return dateRegex.test(value)
        },
        // Перевірка статусу оплати (чи дата в майбутньому)
        isPaid(dateStr) {
            if (!this.isDateValue(dateStr)) return null
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            const paymentDate = new Date(dateStr)
            return paymentDate >= today
        },
        // Отримання класу для блоку на основі статусу оплати
        getPaymentStatusClass(item) {
            if (!this.isDateValue(item.value)) return ''
            const paid = this.isPaid(item.value)
            if (paid === null) return ''
            return paid ? 'payment-paid' : 'payment-expired'
        },
        // Отримання класу тексту для статусу оплати
        getPaymentTextClass(item) {
            if (!this.isDateValue(item.value)) return ''
            const paid = this.isPaid(item.value)
            if (paid === null) return ''
            return paid ? 'text-success' : 'text-danger'
        }
    }
}
</script>

<style scoped>
.info-block-small {
    background-color: var(--vz-card-bg, #fff);
    transition: all 0.2s;
}
.info-block-small:hover {
    background-color: var(--vz-secondary-bg, rgba(0,0,0,0.05));
    transform: translateY(-1px);
}
.breakText h4{
    word-break: break-all;
}
/* Стилі для статусу оплати */
.payment-paid {
    background-color: rgba(var(--vz-success-rgb), 0.1) !important;
    border-color: var(--vz-success) !important;
}
.payment-expired {
    background-color: rgba(var(--vz-danger-rgb), 0.1) !important;
    border-color: var(--vz-danger) !important;
}
</style>